import { render, staticRenderFns } from "./SectionLocation.vue?vue&type=template&id=158f52c5&scoped=true"
import script from "./SectionLocation.vue?vue&type=script&lang=ts"
export * from "./SectionLocation.vue?vue&type=script&lang=ts"
import style0 from "./SectionLocation.vue?vue&type=style&index=0&id=158f52c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f52c5",
  null
  
)

export default component.exports